<template>
  <span v-html="getValueWithUnit($page.props.locale)"></span>
</template>

<script>
export default {
  props: {
    unit: { type: String, default: () => '&times;' },
    value: { type: Number, default: () => 0.0 },
    schema: { type: String, default: '{{ value }} {{ unit }}' },
    settings: { type: Object, default: () => null },
  },
  setup(props) {
    const getFormat = (locale) => {
      return (props.value ?? 0).toLocaleString(locale, getOptions());
    };

    const getValueWithUnit = (locale) => {
      return props.schema.replace('{{ value }}', getFormat(locale)).replace('{{ unit }}', props.unit);
    };

    const getOptions = () => {
      let defaults = { minimumFractionDigits: 0, maximumFractionDigits: 2 };

      return { ...defaults, ...props.settings };
    };

    return {
      getValueWithUnit,
    };
  },
};
</script>
